import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import ListItemsTable from '../../../../../features/components/ListItemsTable'

import { createCampaignSummaryPageLink } from '../../../../Campaigns/helpers'

import {
  campaignsErrorSelector,
  campaignsIsLoadingSelector,
  campaignsSelector,
  campaignsWasLoadedSelector
} from '../../../../../modules/selectors/campaigns'

import { GOOGLE_AD_MANAGER_PLATFORM } from '../../../../../constants/selectLists/platformList'

const GamCampaignsSection = ({ hasNotFetchedCampaigns }) => {
  const campaigns = useSelector(campaignsSelector)

  const wasLoadedSelector = useMemo(() => {
    // If the right doesn't have campaigns to fetch, we consider that campaigns were loaded,
    // but the request to fetch campaigns was not made
    return hasNotFetchedCampaigns ? campaignsWasLoadedSelector : () => true
  }, [hasNotFetchedCampaigns])

  return (
    <ListItemsTable
      items={campaigns}
      platform={GOOGLE_AD_MANAGER_PLATFORM}
      isLoadingSelector={campaignsIsLoadingSelector}
      errorSelector={campaignsErrorSelector}
      wasLoadedSelector={wasLoadedSelector}
      createItemLinkHelper={createCampaignSummaryPageLink}
      nameColumnLabel="Campaign"
      showInsightsColumns={false}
      noDataText="There are currently no campaigns associated with this digital right. To get started, please upload an ad creative."
    />
  )
}

export default GamCampaignsSection
